<template>
  <el-popover
    ref="popover"
    width="400"
    popper-class="sign-popover"
    v-model="visible"
    :disabled="disabled"
    trigger="click"
    placement="bottom-start"
  >
    <div>
      <div class="close">
        <span style="color: #999">请在空白区域签名</span>
        <i class="el-icon-close close-icon" @click="visible = false"></i>
      </div>
      <div class="wrapper">
        <canvas class="signature-pad" id="signature-pad" width="400" height="160" />
      </div>
      <div class="operation">
        <el-button size="mini" @click.native.prevent="clearPanel">
          清空
        </el-button>
        <el-button size="mini" type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
    <template slot="reference">
      <el-input
        :placeholder="placeholder"
        :disabled="disabled"
        v-model="value"
        size="mini"
        clearable
      >
        <div slot="prefix" class="icon">
          <svg-icon icon-class="detail_sign" style="color: #c0c4cc"></svg-icon>
        </div>
      </el-input>
    </template>
  </el-popover>
</template>
<script>
import SignaturePad from "signature_pad"
import { uploadFile, getUrlByPath } from "@/utils/uploadFile"
import { getFileSizeStr, randomString, resolveFileName } from "@/utils/common"
import { uploadAttachment } from "@/api/userCenter/file"
export default {
  name: "sign-popover",
  props: {
    placeholder: String,
    disabled: Boolean
  },
  data() {
    return {
      value: "",
      visible: false,
      signaturePad: null,
      config: {
        // 可配置背景、画笔颜色等
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let canvas = this.$el.querySelector(".signature-pad")
      this.signaturePad = new SignaturePad(canvas, this.config)
    },
    clearPanel() {
      this.signaturePad.clear()
    },
    // 将base64转换为blob
    dataURLtoBlob(dataUrl) {
      let arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.fileName = fileName
      theBlob.name = fileName
      theBlob.uid = Date.now()
      return theBlob
    },
    async confirm() {
      if (this.signaturePad._isEmpty) {
        this.$message.error("无效的签名信息")
      } else {
        let blob = this.dataURLtoBlob(this.signaturePad.toDataURL())
        let file = this.blobToFile(blob, randomString(10) + ".png")
        let { ext } = resolveFileName(file.fileName)
        if (this.limitedFileSuffix && !this.limitedFileSuffix.includes(ext)) {
          throw `文件类型不合法,仅支持 ${this.limitedFileSuffix.join(",")}`
        }
        file.ext = ext
        file.sizeStr = getFileSizeStr(file.size)
        file.tempId = randomString(10)
        let resFile = await uploadFile(file, "sign/")
        uploadAttachment({
          name: resFile.fileName,
          type: resFile.ext,
          path: resFile.uploadPath,
          sizeStr: resFile.sizeStr,
          sizeByte: resFile.size,
          hash: resFile.hash
        }).then(res => {
          this.$emit("change", getUrlByPath(res.data.data.path))
          this.$emit("output", res.data.data)
        })
      }
    },
    focus() {
      this.$refs.popover.doShow()
    }
  }
}
</script>
<style lang="scss">
.sign-popover.el-popover {
  padding: 0;
  .el-input--mini {
    font-size: 14px;
  }
  .close {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    .close-icon {
      font-size: 16px;
      color: #535c65;
    }
  }
  .wrapper {
    position: relative;
    width: 400px;
    height: 160px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    .signature-pad {
      position: absolute;
      left: 0;
      top: 0;
      width: 400px;
      height: 160px;
    }
  }
  .operation {
    padding: 8px;
    border-top: 1px solid #eaecf0;
    text-align: right;
  }
}
</style>
